import React, {useContext} from 'react';
import CreateTemplate from '../scripts/CreateTemplate';
import { v4 as uuidv4 } from 'uuid';
import { LogoContext } from '../../contexts/LogoContext';
import { ColorContext } from '../../contexts/ColorContext';
import { NamePositionContext } from '../../contexts/NamePositionContext';
import { withRouter } from 'react-router-dom';

const TemplateButton = (props) => {
    const { logos } = useContext(LogoContext);
    const { colors } = useContext(ColorContext);
    const { info } = useContext(NamePositionContext);

    const handleClick = async () => {
        let clientId = uuidv4();
        CreateTemplate(clientId, info, colors, logos);
        props.history.push('/template/' + clientId);
    };
    return (
        <button role="link" onClick={handleClick}>
          Create Shareable Template <i class="far fa-plus-square"></i>
        </button>
    );
}

export default withRouter(TemplateButton);